import { Icon } from '@chakra-ui/react';

const PCButtonIcon = (props) => (
	<Icon
		version="1.1"
		id="Layer_1"
		x="0px"
		y="0px"
		viewBox="0 0 30 30"
		fill={'#4A5668'}
		// style="enable-background:new 0 0 1500 1500;"
		{...props}>

		<g>
			<g>
				<path class="st0" d="M14.63,29.32c-0.49,0-0.98,0-1.48,0c-0.85,0-1.32-0.41-1.41-1.24c-0.03-0.27-0.05-0.54-0.07-0.8
			c-0.02-0.32-0.04-0.63-0.09-0.93c-0.06-0.38-0.15-0.67-0.27-0.87c-0.96-1.57-1.96-3.2-2.37-5.13c-0.1-0.46-0.12-0.96-0.09-1.59
			c0.05-0.84,0.52-1.53,1.28-1.88c0.21-0.1,0.29-0.17,0.29-0.54c-0.02-2.54-0.02-5.28-0.01-8.39c0-0.75,0.34-1.42,0.92-1.81
			c0.58-0.4,1.32-0.47,2.02-0.2c0.79,0.31,1.25,0.91,1.28,1.68c0.03,0.8,0.04,1.6,0.05,2.38c0,0.3,0.01,0.59,0.01,0.89
			c0,0.15,0,0.29,0,0.44c0,0.23,0,0.45,0.01,0.67c0,0.08,0.02,0.12,0.03,0.12c0,0,0.01,0,0.02,0c0.01,0,0.02,0,0.03,0
			c1.17-0.12,2.08,0.23,2.78,1.07c0.05,0.02,0.12,0.03,0.16,0.02c1.34-0.25,2.38,0.15,3.09,1.18c0.03,0.02,0.1,0.05,0.18,0.06
			c1.79,0.27,2.83,1.35,3.07,3.2c0.34,2.59-0.18,5.08-1.55,7.4c-0.33,0.55-0.51,1.13-0.58,1.83c-0.03,0.33-0.07,0.71-0.12,1.08
			c-0.12,0.9-0.6,1.32-1.51,1.33c-0.85,0.01-1.7,0-2.55,0l-0.5,0v0.02l-1.59,0C15.32,29.32,14.97,29.32,14.63,29.32z M12.89,28.18
			c0,0,0.06,0.03,0.26,0.03c0.84,0,1.68,0,2.51,0l0.49,0V28.2l1.61,0c0.85,0,1.7,0,2.55,0c0.36,0,0.38-0.02,0.42-0.37
			c0.05-0.36,0.09-0.73,0.12-1.05c0.09-0.85,0.33-1.59,0.73-2.28c1.25-2.1,1.72-4.35,1.41-6.69c-0.18-1.38-0.83-2.06-2.15-2.26
			c-0.3-0.05-0.7-0.2-0.91-0.51c-0.47-0.69-1.07-0.91-2-0.74c-0.37,0.07-0.92-0.04-1.18-0.37c-0.46-0.58-1.03-0.79-1.84-0.71
			c-0.34,0.03-0.66-0.06-0.89-0.26c-0.25-0.21-0.39-0.54-0.41-0.91c-0.01-0.24-0.01-0.48-0.01-0.72c0-0.14,0-0.28,0-0.42
			c0-0.3-0.01-0.6-0.01-0.9c-0.01-0.77-0.02-1.57-0.05-2.35c-0.01-0.21-0.08-0.51-0.58-0.71c-0.36-0.14-0.72-0.11-1,0.08
			c-0.28,0.19-0.44,0.52-0.44,0.91c-0.01,3.1-0.01,5.84,0.01,8.37c0,0.48-0.09,1.16-0.93,1.54c-0.4,0.19-0.62,0.51-0.65,0.95
			c-0.03,0.53-0.01,0.94,0.06,1.3c0.37,1.74,1.31,3.29,2.23,4.78c0.2,0.33,0.34,0.75,0.42,1.28c0.05,0.35,0.07,0.69,0.1,1.02
			c0.02,0.26,0.03,0.5,0.06,0.74C12.85,28.14,12.89,28.18,12.89,28.18L12.89,28.18z"/>
			</g>
			<g>
				<path class="st0" d="M19.9,7.68c-0.22,0.89-0.41,1.79-0.69,2.67c-0.22,0.7-0.65,0.93-1.1,0.76c-0.51-0.19-0.63-0.62-0.35-1.34
			c0.72-1.87,0.56-3.64-0.62-5.28c-1.71-2.38-5.02-2.94-7.41-1.28C7.32,4.89,6.67,8.16,8.27,10.6c0.12,0.18,0.26,0.36,0.38,0.54
			c0.28,0.41,0.26,0.81-0.13,1.11c-0.43,0.33-0.83,0.2-1.15-0.2c-0.89-1.09-1.41-2.35-1.53-3.74c-0.36-4.19,2.91-7.69,7.11-7.63
			C16.69,0.72,19.76,3.87,19.9,7.68z"/>
			</g>
		</g>

	</Icon>
);

export default PCButtonIcon;
